import script from "./HomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=0c1f12f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kevin\\Desktop\\Vue_Shop-Sushiro--main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1f12f6"]])

export default __exports__